import { Util } from "@/utils/util";
import { Component } from "@angular/core";
import { FormDocumentComponent } from "../form-document/form-document.component";
import { MatDialog } from "@angular/material/dialog";
import { ColaboradorService } from "@services/colaborador.service";

@Component({
  selector: "app-information",
  templateUrl: "./information.component.html",
  styleUrls: ["./information.component.scss"],
})
export class InformationComponent {
  sesion;
  pdfSrc = "../assets/pdf/INFORME MAESTROS.pdf"; // Ruta al PDF en la carpeta assets
  defaultImage = "assets/img/default-profile.png";
  backendImage: string | null = null;

  constructor(
    private util: Util,
    private dialog: MatDialog,
    private colaboradorService: ColaboradorService,
  ) {
    this.sesion = this.util.getSesion();
    this.cargarImagenColaborador();
  }

  cargarImagenColaborador(): void {
    if (!this.sesion?.id_colaborador) {
      return;
    }

    this.colaboradorService
      .getFotoColaborador("colaborador", this.sesion.id_colaborador)
      .subscribe({
        next: (resp) => {
          if (resp.success && resp.archivo) {
            const mime = resp.archivo.mime || "image/jpeg";
            const base64 = resp.archivo.file;
            this.backendImage = `data:${mime};base64,${base64}`;
          }
        },
        error: () => {
          this.backendImage = null;
        },
      });
  }

  get imageToShow(): string {
    return this.backendImage || this.defaultImage;
  }

  openPdf() {
    window.open(this.pdfSrc, "_blank");
  }
  openDocuments(): void {
    this.dialog.open(FormDocumentComponent, {
      width: "900px",
      disableClose: true,
      data: {
        id_colaborador:  this.sesion.id_colaborador,
      },
    });
  }
}
